const Discount = ({ val, label }) => {
    if (!val !== false) return null;

    return (
        <div className="rounded-sm gradient-border bg-white text-center md:w-full lg:w-fit">
            <p className="line-clamp-1 text-xs px-2 py-1 md:py-1 py-1 bg-[#fbfaf9]">{label}</p>
        </div>
    );
}

export default Discount